import styles from './NewSessionComposerPlaceholder.module.css'

// Holds the composer's resting height while its code loads, so the content around it doesn't move when it appears.
export function NewSessionComposerPlaceholder({
  isNewConversation = false,
  isReadOnly,
}: {
  isNewConversation?: boolean
  isReadOnly: boolean
}) {
  return (
    <div
      className={styles.Placeholder}
      data-new-conversation={isNewConversation}
      data-read-only={isReadOnly}
      aria-hidden="true"
    />
  )
}
